const StatusPill = ({
  label,
  bgColor,
  textColor,
  borderColor,
}) => {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "6px 14px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 600,
        letterSpacing: "0.4px",
        textTransform: "uppercase",
        backgroundColor: bgColor,
        color: textColor,
        border: `1px solid ${borderColor}`,
      }}
    >
      {label}
    </span>
  );
};

export default StatusPill;
